export const ON_FAV_CLICKED = 'fav:clicked';

export const FAV_LOCAL = 'fav_local';


export const FAV_URL_ADD = 'fav-api/add/';
export const FAV_URL_REMOVE = 'fav-api/remove/';
export const FAV_URL_SAVE = 'fav-api/save?';
export const FAV_URL_FEED = 'fav-api/load/';
